import { Map } from '@components/listing/neighborhood/Map';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { LatLng } from '@utils/types/locations';
import { MarkerType } from '@utils/types/maps';
import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './styles.module.scss';

type Props = {
  listingLocation: LatLng;
} & BaseComponentProps;

Neighborhood.defaultProps = { neighborhood: [] };

export function Neighborhood(props: Props) {
  const { containerStyle, listingLocation } = props;
  const [mapMarkers] = useState<MarkerType[]>([
    {
      position: {
        lat: listingLocation.lat,
        lng: listingLocation.lng,
      },
      type: 'property',
    },
  ]);

  return (
    <div className={clsx([styles.neighborhoodContainer, containerStyle])}>
      <h4 className={styles.title}>The Neighborhood</h4>

      <div className={styles.container}>
        <Map
          zoom={15}
          markers={mapMarkers}
          containerStyle={styles.map}
          center={listingLocation}
        />
      </div>
    </div>
  );
}
